module.exports = __webpack_public_path__ + "images/3facba1c25869a794ee9106112e87372-LoginBrandImg.jpg";